var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',_vm._l((_vm.items),function(item){return _c('v-col',{key:item.id},[_c('signle',{attrs:{"record":item}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }